import { AxiosResponse } from 'axios';
import { apiClient } from '../instance';
import {
  ReportParams,
  TicketReportData,
  OperatorReportData,
  ClientReportData,
  ProductReportData,
} from '../../types/reportInterfaces';

const BASE = '/helpdesk/reports';

/** Убирает пустые значения из параметров отчёта. */
function cleanParams(params: ReportParams): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') out[k] = v as string | number;
  });
  return out;
}

export const reportsApi = {
  tickets: (params: ReportParams = {}): Promise<AxiosResponse<TicketReportData>> =>
    apiClient.get<TicketReportData>(`${BASE}/tickets/`, { params: cleanParams(params) }),

  operators: (params: ReportParams = {}): Promise<AxiosResponse<OperatorReportData>> =>
    apiClient.get<OperatorReportData>(`${BASE}/operators/`, { params: cleanParams(params) }),

  clients: (params: ReportParams = {}): Promise<AxiosResponse<ClientReportData>> =>
    apiClient.get<ClientReportData>(`${BASE}/clients/`, { params: cleanParams(params) }),

  products: (params: ReportParams = {}): Promise<AxiosResponse<ProductReportData>> =>
    apiClient.get<ProductReportData>(`${BASE}/products/`, { params: cleanParams(params) }),

  exportProducts: (
    format: 'csv' | 'xlsx',
    params: ReportParams = {},
  ): Promise<AxiosResponse<Blob>> =>
    apiClient.get(`${BASE}/products/export/`, {
      params: { ...cleanParams(params), format },
      responseType: 'blob',
    }),

  exportTickets: (
    format: 'csv' | 'xlsx',
    params: ReportParams = {},
  ): Promise<AxiosResponse<Blob>> =>
    apiClient.get(`${BASE}/tickets/export/`, {
      params: { ...cleanParams(params), format },
      responseType: 'blob',
    }),

  exportOperators: (
    format: 'csv' | 'xlsx',
    params: ReportParams = {},
  ): Promise<AxiosResponse<Blob>> =>
    apiClient.get(`${BASE}/operators/export/`, {
      params: { ...cleanParams(params), format },
      responseType: 'blob',
    }),
};

/** Скачивание blob-ответа экспорта как файла. */
export function downloadReportBlob(data: Blob, filename: string): void {
  const url = window.URL.createObjectURL(data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
